import { Droplets, Sparkles, Baby, ShowerHead } from "lucide-react";

const GROUPS = [
  {
    icon: Droplets,
    title: "Kuivalle ja herkälle iholle",
    text: "Puhtaampi vesi auttaa ehkäisemään ihon kuivumista ja voi vähentää ärsytystä ja kutinaa.",
  },
  {
    icon: Sparkles,
    title: "Kuiville ja sameille hiuksille",
    text: "Suodatettu vesi tukee hiusten kosteutta, kiiltoa ja elinvoimaa pesusta pesuun.",
  },
  {
    icon: Baby,
    title: "Lapsiperheille",
    text: "Hellävarainen valinta koko perheen herkälle iholle – testattu ja turvallinen.",
  },
  {
    icon: ShowerHead,
    title: "Paremman suihkuveden kaipuuseen",
    text: "Kaikille, jotka haluavat parantaa suihkuveden laatua ja päivittäistä hyvinvointia.",
  },
];

export default function TargetGroups() {
  return (
    <section data-testid="target-groups-section" className="py-24 md:py-36 bg-water-soft/50">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <p className="eyebrow text-water-deep/80">Kenelle?</p>
          <h2 className="h-section font-heading mt-5 font-semibold text-foreground" lang="fi">
            Kenelle JINSU sopii?
          </h2>
        </div>
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {GROUPS.map((g) => (
            <article
              key={g.title}
              data-testid={`target-group-${g.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group rounded-[2rem] bg-white p-8 shadow-[0_10px_40px_-18px_rgba(23,68,94,0.18)] transition-transform duration-300 hover:-translate-y-1.5"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-water text-water-deep transition-transform duration-300 group-hover:scale-110">
                <g.icon size={22} strokeWidth={1.8} />
              </span>
              <h3 className="font-heading mt-6 text-lg font-semibold leading-snug text-foreground" lang="fi">
                {g.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{g.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
